export type JsonSchema7AnyType = { $ref?: string };

export function parseAnyDef(): JsonSchema7AnyType {
  return {};
}
